import axios from 'axios';

export const adminLogin = (token, data) => axios.post(`${process.env.REACT_APP_BASE_URL}Authentication/User-Login-By-Admin`, data, { headers: { 'Authorization': "Bearer " + token } });